import { FeedbackDialog } from '@/components/form/feedback-dialog'
import { MinutaToolbar } from '../minutaToolbar'
import { MinutaContent } from '../minutaContent'
import useMinuta from '../useMinuta'
import { generatePDF } from '../../utils/pdf-util'

export default function MinutaPage() {
  const {
    id,
    user,
    client,
    agreementData,
    historySuggestions,
    isSpeaking,

    message,
    isDialogOpen,
    fullStyledHtml,
    displaySignatureIsVerifedButton,
    editableHtml,
    shouldShowLoading,
    selectedIcon,
    displaySignatureButton,
    canCloseContract,
    shouldContinueWitnessFlow,
    handleSpeak,
    handleStop,
    handleClient,
    handleSave,
    handleUpdateAgreement,
    handleBack,
    agreementError,
    signatureError,
    nextWitnessSlot,
    setIsDialogOpen
  } = useMinuta()

  if (!id) return <div>Erro: nenhum ID foi fornecido.</div>
  if (agreementError) return <div>Erro ao carregar o contrato: {agreementError.message}</div>
  if (signatureError)
    return <div className="text-center text-red-600">Erro ao verificar assinatura. Tente novamente.</div>

  return (
    <div className="container mx-auto p-4 flex flex-col items-center w-full">
      <MinutaToolbar
        isSpeaking={isSpeaking}
        handleSpeak={handleSpeak}
        handleStop={handleStop}
        agreementData={agreementData}
        displaySignatureButton={displaySignatureButton}
        displaySignatureIsVerifedButton={displaySignatureIsVerifedButton}
        canCloseContract={canCloseContract}
        shouldContinueWitnessFlow={shouldContinueWitnessFlow}
        isSignatureLoading={false}
        isFetching={false}
        handleClient={handleClient}
        handleUpdateAgreement={handleUpdateAgreement}
        selectedIcon={selectedIcon}
        id={id}
        historySuggestions={historySuggestions}
        fullStyledHtml={fullStyledHtml}
        generatePDF={() => {
          generatePDF(fullStyledHtml, selectedIcon, id)
        }}
        user={user}
        client={client}
        handleBack={handleBack}
        nextWitnessSlot={nextWitnessSlot}
      />
      <MinutaContent
        shouldShowLoading={shouldShowLoading}
        editableHtml={editableHtml}
        fullStyledHtml={fullStyledHtml}
        handleSave={handleSave}
        selectedIcon={selectedIcon}
        historySuggestions={historySuggestions}
      />
      <FeedbackDialog isOpen={isDialogOpen} onOpenChange={setIsDialogOpen} message={message!} />
    </div>
  )
}
